const ScheduleIndex = () => import('@/views/Dashboard/Schedule/ScheduleIndex');
const Calender = () => import('@/views/Dashboard/Schedule/Calender');
const Events = () => import('@/views/Dashboard/Schedule/Event/Events');
const Classes = () => import('@/views/Dashboard/Schedule/Classes/Classes');
const ClassDetails = () => import('@/views/Dashboard/Schedule/Classes/ClassDetails');
const ClassSeries = () => import('@/views/Dashboard/Schedule/Classes/Series/ClassSeries');
const AttendenceView = () => import('@/views/Dashboard/Schedule/Classes/AttendenceView/AttendenceView');
const GroupGateAccess = () => import('@/views/Dashboard/SystemSettings/Gates/GroupView/GroupGatesAccess');
const GroupEnrollments = () => import('@/views/Dashboard/Schedule/Classes/GroupEnrollments/GroupEnrollments');
const SessionDetail = () => import('@/views/Dashboard/Schedule/Classes/SessionDetail/SessionDetail');
const StaffRota = () => import('@/views/Dashboard/Schedule/Rota/StaffRota');

export default {
  path: '/schedule',
  component: ScheduleIndex,
  children: [
    {
      path: 'calender',
      name: 'calender',
      component: Calender,
      meta: { preserveTableState: true },
    },
    {
      path: 'rota',
      name: 'staff-rota',
      component: StaffRota,
      meta: { preserveTableState: true },
    },
    {
      path: 'events',
      name: 'events',
      component: Events,
      meta: { preserveTableState: true },
    },
    {
      path: 'classes',
      name: 'classes',
      component: Classes,
      meta: {
        preserveTableState: true,
        resetPageStateOnLeave: true,
        pageFilterStorageKeys: [
          'classDivisionFilter',
          'classStatusFilter',
          'classActivityFilter',
        ],
      },
    },
    {
      path: 'classes/:id/details',
      name: 'class-details',
      component: ClassDetails,
      meta: { preservePageStateFor: 'classes' },
    },
    {
      path: 'gates-access/groups/:id',
      name: 'grouped-gates-access',
      component: GroupGateAccess,
    },
    {
      path: 'classes-series/:classid',
      name: 'classes-series',
      component: ClassSeries,
      meta: { preservePageStateFor: 'classes' },
    },
    {
      path: 'classes/attendance/:id',
      name: 'attendance-view',
      component: AttendenceView,
      meta: { preservePageStateFor: 'classes' },
    },
    {
      path: 'classes/:classid/enrollments',
      name: 'group-enrollments',
      component: GroupEnrollments,
      meta: { preservePageStateFor: 'classes' },
    },
    {
      path: 'sessions/:id',
      name: 'session-detail',
      component: SessionDetail,
      meta: { preservePageStateFor: 'classes' },
    },
  ],
};
